import {Carteira} from "../../carteira/carteira.model";
import {Regra} from "../../regra/regra";

export class DadosCarteiraRegraModel {
    regras: Regra[] = [];
    carteiras: Carteira[] = [];
}
